import React from 'react';

import './Button.scss';

type ButtonVariant = 'dark' | 'light' | 'orange' | 'yellow' | 'purple' | 'danger';

export type BaseButtonProps = {
    label?: string;
    callback?: () => any;
    icon?: React.ReactNode;
    iconBefore?: boolean;
    iconAfter?: boolean;
    chip?: number;
    disabled?: boolean;
    variant?: ButtonVariant;
    isUser?: boolean;
};

export type ButtonProps = BaseButtonProps &
    (
        | {
              icon: React.ReactNode;
              iconBefore: boolean;
              iconAfter?: never;
          }
        | {
              icon: React.ReactNode;
              iconBefore?: never;
              iconAfter: boolean;
          }
        | {
              icon?: undefined;
              iconBefore?: boolean;
              iconAfter?: boolean;
          }
    ) & {
        iconHoverAnimation?: 'rotate' | 'shake';
        variant?: ButtonVariant;
    } & React.ComponentPropsWithoutRef<'button'>;

export const Button: React.FC<ButtonProps> = ({
    label,
    callback,
    icon,
    iconHoverAnimation,
    variant = 'dark',
    className,
    chip,
    iconBefore = false,
    iconAfter = false,
    disabled = false,
    type = 'submit', 
    isUser = false,
    ...props 
}) => {
    return (
        <button
            className={`button ${iconHoverAnimation ?? ''} ${variant} ${className ?? ''} ${isUser ? 'user' : ''}`}
            onClick={() => callback && callback()}
            disabled={disabled}
            type={type}
            {...props} 
        >
            {(chip && chip > 0) ? <span className="btn-chip">{chip}</span> : null}
            {icon && iconBefore && <>{icon}</>}
            {isUser ? <span>{label}</span> : <>{label}</>}
            {icon && iconAfter && <>{icon}</>}
        </button>
    );
};
